/**
 * Faceted search - Clear button
 *
 * Implements the functionality of the "Clear" -button in the text field in faceted search.
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let text_field = document.querySelector('.js-faceted-search-text-field');
    let clear_button = document.querySelector(
        '.js-faceted-search-text-field-clear-button'
    );

    if (!form || !text_field || !clear_button) {
        return;
    }

    function clearTextField() {
        text_field.value = '';
        text_field.focus();
    }

    function updateClearButtonVisibility(e) {
        // console.log('text_field.value', text_field.value);

        if (text_field.value === '') {
            clear_button.classList.remove('-visible');
        } else {
            clear_button.classList.add('-visible');
        }
    }

    clear_button.addEventListener('click', (e) => {
        clearTextField();
        form.dispatchEvent(new Event('input'));
    });

    form.addEventListener('input', updateClearButtonVisibility);
    text_field.addEventListener('input', updateClearButtonVisibility);

    updateClearButtonVisibility();
})();
